<div class="mb-3">
  @if (label != null) {
    <label for="{{ id }}">{{ label }}</label>
  }
  @if (showRequired) {
    <span class="required-indicator"> *</span>
  }
  <input type="text" [typeahead]="list" [typeaheadMinLength]="0" id="{{ id }}" class="form-control" [formControl]="control" />
  @if (control.invalid) {
    <span class="help-block">
      <span class="required-indicator">
        {{ getErrorMessage() }}
      </span>
    </span>
  }
</div>
